const messages = {
  title: "Cenu saraksti un produktu brošūras",
  description:
    "Lejupielādējiet jaunākās brošūras un bukletus par Bridgestone un Firestone riepām vieglajiem auto, SUV un komerciālajiem transportlīdzekļiem.",
  brochureCategories: {
    products: "Produkti",
    brand_and_solutions: "Zīmols un risinājumi",
    season_and_promotions: "Sezona un akcijas",
    format: "Formāts",
    cars_and_vans: "Vieglā auto, SUV, komercauto",
    summer: "Vasara",
    winter: "Ziema",
    promotions: "Akcijas",
    all_season: "Vissezonas",
    truck_and_buses: "Smagā auto un autobuss",
    motorcycle: "Motocikls",
    agriculture: "Lauksaimniecība",
    construction_machinery: "Būvtehnika",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiāli",
    brochures: "Produktu brošūras",
    price_list: "Cenu saraksti",
    materials: "Materiāli",
    video_in_store: "Video ar subtitriem",
    video_online: "Video bez subtitriem",
    banner_website: "Baneris",
    banner_social_media: "Sociālie mediji",
    logos: "Logotipi",
  },
  searchMedia: "Ievadiet atslēgvārdu",
  searchResults: "Meklēšanas rezultāti",
};

export default {
  messages,
};
